import { render, staticRenderFns } from "./FaCheDetail.vue?vue&type=template&id=d5949b58&"
import script from "./FaCheDetail.vue?vue&type=script&lang=js&"
export * from "./FaCheDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports